import { KEY_SEPARATOR } from '../common/constants';
import { MarketplaceIdToLabel } from '../../const/dropdown_elements';

export const formatHeadingDisplay = (heading, format) => {
  if (heading.startsWith('[')) {
    let separator = heading.indexOf(']') + 1;
    heading = (
      <span>
        {heading.slice(0, separator)}
        <br />
        {heading.slice(separator)}
      </span>
    );
  }

  return format !== 'string' ? (
    <span className="awsui-util-t-r awsui-util-d-b">{heading}</span>
  ) : (
    <span className="awsui-util-d-b">{heading}</span>
  );
};

export const formatCellDisplay = (cellValue, format, displayInMillions, item = null) => {
  let cellValueFormatted = formatNumber(cellValue, format, displayInMillions)
  const cellStyle = getCellDisplayStyle(item);
  const className = format !== 'string' ? 'awsui-util-t-r awsui-util-d-b' : 'awsui-util-d-b';

  return (
    <span className={className} style={cellStyle}>
      {cellValueFormatted}
    </span>
  );
};

export const formatNumber = (cellValue, format, displayInMillions) => {
  const inMillions = format === 'monetary' && displayInMillions;
  let cellValueFormatted = cellValue;

  if (inMillions) {    
    cellValueFormatted = isNaN(cellValue) ? 'N/A' : new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(cellValue/1000000);
  } else if ((cellValue === 0.0 || cellValue === -0.0) && format === 'decimal') {
    cellValueFormatted = 'N/A';
  } else if (format === 'decimal') {
    cellValueFormatted = isNaN(cellValue) ? 'N/A' : cellValue.toFixed(2);
  } else if ((cellValue === 0.0 || cellValue === -0.0) && format === 'percent') {
    cellValueFormatted = '0.00  %';
  } else if (format === 'percent') {
    cellValueFormatted = isNaN(cellValue) ? 'N/A' : cellValue.toFixed(2) + ' %';
  } else if (inMillions === false && format !== 'string') {
    cellValueFormatted = isNaN(cellValue)
      ? 'N/A'
      : new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(cellValue);
  }

  return cellValueFormatted === '-0' ? '0' : cellValueFormatted;
}

export const getCellDisplayStyle = (item) => {
  return item && item['level'] === 3 ? { color: '#006600', fontStyle: 'italic' } : null;
};

export const getColumnFormats = (columnConfig) => {
  const { columns } = columnConfig;
  return columns.reduce((acc, cur) => ({ ...acc, [cur.id]: cur.format }), {});
};

export const getFormat = (key, columnFormats) => {
  const columnKey = key.includes(KEY_SEPARATOR) ? key.split(KEY_SEPARATOR)[1] : key;
  const format = columnFormats[columnKey];

  return format ? format : 'string';
};

const MONTH_MAP = {
  '01': 'Jan',
  '02': 'Feb',
  '03': 'Mar',
  '04': 'Apr',
  '05': 'May',
  '06': 'Jun',
  '07': 'Jul',
  '08': 'Aug',
  '09': 'Sep',
  '10': 'Oct',
  '11': 'Nov',
  '12': 'Dec',
};

export const formatDate = (time, fullYear = false, separator = '-') => {
  let timeFrames = time.split(',');
  let formatedFrame = [];
  for (let timeFrame of timeFrames) {
    if (timeFrame.includes('/')) {
      const yearStart = fullYear ? 0 : 2;
      formatedFrame.push(MONTH_MAP[timeFrame.slice(5)] + separator + timeFrame.slice(yearStart, 4));
    } else if (timeFrame.includes('Q')) {
      formatedFrame.push(timeFrame.slice(4) + '-' + timeFrame.slice(2, 4));
    } else {
      formatedFrame.push(timeFrame);
    }
  }
  return formatedFrame.join(', ');
};

export const formatMarketplace = (marketplaceId) => {
  return MarketplaceIdToLabel[marketplaceId];
};



// WEBPACK FOOTER //
// ./src/components/reports/utils/formatting.js